import { c as _c } from "react/compiler-runtime";
import { FontWeights, Tooltip } from "@flat-ui";
import { UserAvatarWithMenu } from "@components/user-more-info-menu/user-avatar-with-menu";
import { UiUtils } from "@stellar/utils";
import { withEllipsis } from "@styles/common-styles";
/** Renders the user column fields in transactions table */
export function TransactionUser(t0) {
  const $ = _c(14);
  const {
    member
  } = t0;
  if (!member) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <var>{UiUtils.DASH}</var>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] !== member) {
    t1 = <UserAvatarWithMenu member={member} />;
    $[1] = member;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== member.name) {
    t2 = <var>{member.name}</var>;
    $[3] = member.name;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      display: "block",
      ...withEllipsis,
      fontWeight: FontWeights.Bold,
      cursor: "default",
      marginLeft: "6px"
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== member.name) {
    t4 = <var>{member.name}</var>;
    $[6] = member.name;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t4) {
    t5 = <Tooltip component="var" title={t2} sx={t3}>{t4}</Tooltip>;
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t1 || $[12] !== t5) {
    t6 = <>{t1}{t5}</>;
    $[11] = t1;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}